import { IChildProp } from "@intelligence/components/Form/type";

const COMPARE_PC_AND_CONSOLE_GAMES: IChildProp[] = [
  {
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      isDefault: true,
      enumKey: 'pcu',
    }, {
      isDefault: true,
      enumKey: 'acu',
    }, {
      isDefault: true,
      enumKey: 'mau',
    }, {
      isDefault: true,
      enumKey: 'digitalRevenue',
    }, {
      isDefault: true,
      enumKey: 'units',
    }, {
      isDefault: true,
      enumKey: 'astSimple',
    }, {
      isDefault: true,
      enumKey: 'digitalARPPU',
    }, {
      isDefault: true,
      enumKey: 'physicalRevenue',
    }],
  }, {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }],
  }, {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'timeSettingsByTime',
      enumTargetType: 'downloadMainCategory',
      condition: 'timeSettings:byTime',
      type: 'checkboxGroup',
      children: [{
        enumKey: 'daily',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:dateType:daily',
      }, {
        enumKey: 'weekly',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:dateType:weekly',
      }, {
        enumKey: 'monthly',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:dateType:monthly',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'text',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  }
];

const COMPARE_MOBILE_STORE_RANK: IChildProp[] = [
  {
    enumKey: 'dataSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      isDefault: true,
      enumKey: 'appStore',
      enumTargetType: 'platformMobile',
    }, {
      isDefault: true,
      enumKey: 'googlePlay',
      enumTargetType: 'platformMobile',
    }],
  }, {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }],
  }, {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'editionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      children: [{
        enumKey: 'isEditionAggregated',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'dateSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      children: [{
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'specialCountrySettring',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'text',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  }
];

const COMPARE_MOBILE: IChildProp[] = [
  {
    enumKey: 'dataSource',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'appannie_mobile',
      enumTargetType: 'dataSource',
      isNoIcon: true,
      defaultSelectCondition: 'additionalFields:dataSource:[]appannie',
    }, {
      enumKey: 'sensortower_mobile',
      enumTargetType: 'dataSource',
      isNoIcon: true,
      defaultSelectCondition: 'additionalFields:dataSource:[]sensortower',
    }],
  }, {
    enumKey: 'metrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      label: 'Active Users',
      labelKey: 'dbi_active_users',
      value: 'dau',
      isDefault: true,
    }, {
      label: 'Revenue',
      labelKey: 'dbi_revenue',
      value: 'revenue',
      isDefault: true,
    }, {
      label: 'Downloads',
      labelKey: 'dbi_downloads',
      value: 'download',
      isDefault: true,
    }],
  }, {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }],
  }, {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'editionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      children: [{
        enumKey: 'isEditionAggregated',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
        msgKey: 'dbi_info_mobile_time_settings_info',
      }]
    }, {
      label: '',
      value: 'timeSettingsDateType',
      condition: 'timeSettings:byTime',
      type: 'checkboxGroup',
      children: [{
        enumKey: 'daily',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:dateType:daily',
      }, {
        enumKey: 'weekly',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:dateType:weekly',
      }, {
        enumKey: 'monthly',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:dateType:monthly',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'text',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  }
];

const COMPARE_MULTI_DIMENSION: IChildProp[] = [
  {
    enumKey: 'mutilMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'cascader',
    children: [{
      enumKey: 'mscience',
      enumTargetType: 'dataSource',
      children: [{
        enumKey: 'digitalRevenue',
      }, {
        enumKey: 'digitalUnits',
      }, {
        enumKey: 'digitalARPPU',
      }, {
        enumKey: 'astSimple',
      }]
    }, {
      enumKey: 'steamData',
      enumTargetType: 'dataSource',
      children: [{
        enumKey: 'SteamPCU',
      }, {
        enumKey: 'SteamACU',
      }, {
        enumKey: 'steamData_SteamFollowers',
      }, {
        enumKey: 'steamData_SteamReviews',
      }, {
        enumKey: 'steamData_premiumRevenue',
      }, {
        enumKey: 'steamData_cumulativeRevenue',
      }, {
        enumKey: 'steamData_unit',
      }, {
        enumKey: 'steamData_cumulativeUnits',
      }, {
        enumKey: 'steamData_price',
      }, {
        enumKey: 'steamData_lifetimeWeightedPrice',
      }, {
        enumKey: 'steamData_playersByCountry',
      }, {
        enumKey: 'steamData_avgPlaytime',
      }, {
        enumKey: 'steamData_totalFollowers',
      }]
    }, {
      enumKey: 'gsd',
      enumTargetType: 'dataSource',
      disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
      children: [{
        enumKey: 'digitalUnitsGSD',
      }, {
        enumKey: 'physicalUnitsGSD',
      }, {
        enumKey: 'digitalRevenueGSD',
      }, {
        enumKey: 'physicalRevenueGSD',
      }]
    }, {
      enumKey: 'npd',
      enumTargetType: 'dataSource',
      disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:weekly',
      children: [{
        enumKey: 'physicalRevenue',
      }, {
        enumKey: 'physicalUnits',
      }]
    }, {
      enumKey: 'newzoo',
      enumTargetType: 'dataSource',
      disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
      children: [{
        enumKey: 'mau',
      }, {
        enumKey: 'playerShare',
      }, {
        enumKey: 'mauGrowth',
      }, {
        enumKey: 'mauNew',
      }, {
        enumKey: 'mauReturning',
      }, {
        enumKey: 'lifetimePlayer',
      }, {
        enumKey: 'timeSpent0h',
      }, {
        enumKey: 'timeSpent1h',
      }, {
        enumKey: 'timeSpent5h',
      }, {
        enumKey: 'timeSpent10h',
      }, {
        enumKey: 'timeSpent25h',
      }, {
        enumKey: 'timeSpent50h',
      }, {
        enumKey: 'avgDailyPlaytime',
      }, {
        enumKey: 'avgDailySessions',
      }, {
        enumKey: 'avgPlaytimePerSession',
      }, {
        enumKey: 'avgMonthlyPlaytime',
      }, {
        enumKey: 'avgMonthlySessions',
      }, {
        enumKey: 'avgDaysPlayed',
      }, {
        enumKey: 'stickness',
      }, {
        enumKey: 'totalHours',
      }, {
        enumKey: 'churn',
      }, {
        enumKey: 'acquisition',
      }, {
        enumKey: 'retentionD1',
      }, {
        enumKey: 'retentionD2',
      }, {
        enumKey: 'retentionD4',
      }, {
        enumKey: 'retentionD7',
      }, {
        enumKey: 'retentionD14',
      }, {
        enumKey: 'retentionD28',
      }]
    }, {
      enumKey: 'hatchet',
      enumTargetType: 'dataSource',
      children: [{
        enumKey: 'hoursWatched',
      }, {
        enumKey: 'airtime',
      }, {
        enumKey: 'peakCCV',
      }, {
        enumKey: 'avgCCV',
      }]
    // Famitsu is temporarily unavailable in Compare downloads; keep configuration for rollback.
    // }, {
    //   enumKey: 'famitsu',
    //   enumTargetType: 'dataSource',
    //   disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
    //   children: [{
    //     enumKey: 'famitsu_salesOfSelectedTime',
    //   }, {
    //     enumKey: 'famitsu_revenueOfSelectedTime',
    //   }, {
    //     enumKey: 'famitsu_cumulativeSales',
    //   }, {
    //     enumKey: 'famitsu_cumulativeRevenueFamitsu',
    //   }, {
    //     enumKey: 'famitsu_priceFamitsu',
    //   }]
    // }, {
    }, {
      enumKey: 'options',
      enumTargetType: 'dataSource',
      isNoIcon: true,
      children: [{
        enumKey: 'mentions_options',
      }, {
        enumKey: 'brandHealth_options',
      }, {
        enumKey: 'steamAllReviews_options',
      }, {
        enumKey: 'steamAllReviewsPositive_options',
      }, {
        enumKey: 'steamAddedReviews_options',
      }, {
        enumKey: 'steamAddedPositive_options',
      }]
    }]
  }, {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasSteamId',
      enumTargetType: 'downloadBasicInfo',
    }],
  }, {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        isDefault: true,
        enumKey: 'isByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isByCountries',
        enumTargetType: 'downloadDataCalcu',
        defaultSelectCondition: 'additionalFields:tabType:countries',
      }, {
        enumKey: 'isByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      label: 'Platform Settings',
      labelKey: 'dbi_label_platform_settings',
      value: 'deviceSettings',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isSegmentAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isBySegment',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      label: 'Segment Settings',
      labelKey: 'dbi_label_segment_settings',
      value: 'segmentSettings',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isSegmentAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isBySegment',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }
];

export default {
  comparePCAndConsole: COMPARE_PC_AND_CONSOLE_GAMES,
  compareMobileStoreRank: COMPARE_MOBILE_STORE_RANK,
  compareMobile: COMPARE_MOBILE,
  compareMutilDimension: COMPARE_MULTI_DIMENSION,
};
